import ngDynamicLocale from 'angular-dynamic-locale';
import 'angular-i18n/angular-locale_de'; // <-- preload "de" as default locale

export default angular
  .module('ng1-locale', [ngDynamicLocale])
  .config(tmhDynamicLocaleProvider => {
    'ngInject';
    // Enable dynamic load of locale files
    tmhDynamicLocaleProvider.localeLocationPattern('angular-locale_{{locale}}.js');
  })
  .run(tmhDynamicLocale => {
    'ngInject';
    // Load "de" as default locale
    tmhDynamicLocale.set('de');
  })
  .name;
